module.exports = __webpack_public_path__ + "fonts/Noto_Sans_SC-300-92.94282a6.woff2";